import { ISectorResponse } from '../../../api/IApiResponse';
import { SectorInclination } from '../../../enum/Sector';

export const calculateAngle = (height: number, width: number) => {
    let hypotenuse = Math.hypot(height, width);
    let radians = Math.asin(height / hypotenuse);
    return radians * (180 / Math.PI);
};

export const calculateGabionWidth = (height: number) => {
    return height / Math.tan((84 * Math.PI) / 180);
};

export const calculateByAngleWidth = (height: number, angle: number) => {
    return height / Math.tan((angle * Math.PI) / 180);
};

export const degreesToRadians = (deg: number): number => deg * (Math.PI / 180);

export const MAX_ANGLE = 84;

export const roundToOne = (num: number | undefined): number => {
    if (!num) return 0;
    return parseFloat(num.toFixed(1));
};
export const roundToTwo = (num: number | undefined): number => {
    if (!num) return 0;
    return parseFloat(num.toFixed(2));
};

export const roundToThree = (num: number | undefined): number => {
    if (!num) return 0;
    return parseFloat(num.toFixed(3));
};

export const roundToFour = (num: number): number => {
    return parseFloat(num.toFixed(4));
};

export const handleChangeInclination = (sector: ISectorResponse): ISectorResponse | undefined => {
    let w = 0;
    switch (sector.inclination) {
        case SectorInclination.OneToOne:
            return {
                ...sector,
                width: sector.height,
                angle: 45,
                length: roundToTwo(Math.hypot(sector.height, sector.height)),
            };
        case SectorInclination.OnePointFiveToOne:
            w = sector?.height * 1.5;
            return {
                ...sector,
                width: w,
                angle: 33.69,
                length: roundToTwo(Math.hypot(sector.height, w)),
            };
        case SectorInclination.OnePointSeventFiveToOne:
            w = sector?.height * 1.75;
            return {
                ...sector,
                width: w,
                angle: 29.74,
                length: roundToTwo(Math.hypot(sector.height, w)),
            };
        case SectorInclination.TwoToOne:
            w = sector?.height * 2;
            return {
                ...sector,
                width: w,
                angle: 26.57,
                length: roundToTwo(Math.hypot(sector.height, w)),
            };
        case SectorInclination.ThreeToOne:
            w = sector?.height * 3;
            return {
                ...sector,
                width: w,
                angle: 18.43,
                length: roundToTwo(Math.hypot(sector.height, w)),
            };
        case SectorInclination.TwoToThree:
            w = (sector?.height * 3) / 2;
            return {
                ...sector,
                width: w,
                angle: 33.69,
                length: roundToTwo(Math.hypot(sector.height, w)),
            };
        case SectorInclination.NinetyDegrees:
            return {
                ...sector,
                width: 0,
                angle: 90,
                length: roundToTwo(Math.hypot(sector.height, w)),
            };
        case SectorInclination.GabionSixDegrees:
            return {
                ...sector,
                width: roundToTwo(calculateGabionWidth(sector.height)),
                angle: MAX_ANGLE,
                length: roundToTwo(Math.hypot(sector.height, w)),
            };
        case SectorInclination.Plain:
            return {
                ...sector,
                height: 0,
                angle: 0,
                length: roundToTwo(Math.hypot(sector.height, sector.width)),
            };
        case SectorInclination.ByAngle:
            w = roundToTwo(calculateByAngleWidth(sector?.height, sector?.angle));
            return {
                ...sector,
                width: w,
                length: roundToTwo(Math.hypot(sector.height, w)),
            };
    }
};
